import React from 'react';

const MenuIcon: React.SFC<{}> = () => (
    <svg viewBox="0 0 32 32">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Menu" fill="currentColor">
                <g id="Group-2" transform="translate(0, 3.55555556)">
                    <rect id="Rectangle-3" x="0" y="0" width="32" height="3.55555556" />
                    <rect id="Rectangle-3-Copy" x="0" y="10.6666667" width="32" height="3.55555556" />
                    <rect id="Rectangle-3-Copy-2" x="0" y="21.3333333" width="32" height="3.55555556" />
                </g>
            </g>
        </g>
    </svg>
);
export { MenuIcon };
